import React from 'react'
import Text from '../Text'

const HowItWorksSection = ({ data }) => {
  const title = data?.title
  const journeySteps = Array.isArray(data?.steps) ? data.steps : []
  const cardBGColor = data?.primaryColor ?? '#197CBF'
  const cardShadowColor = data?.secondaryColor ?? '#09436A'

  function renderTitleWithImage(title, image) {
    if (!title?.includes('replaceImage') || !image) {
      return (
        <Text
          tag="div"
          variant="title"
          size="small"
          className="text-primary-text pr-4 !leading-[1.3]"
        >
          {title}
        </Text>
      )
    }
    const parts = title?.split('replaceImage')
    return (
      <Text
        tag="div"
        variant="title"
        size="small"
        className="text-primary-text pr-4 !leading-[1.3]"
      >
        {parts[0] && <span>{parts[0].trim()}</span>}
        <img
          src={image}
          alt=""
          className="h-4 w-[90px] object-contain inline-block mx-1"
        />

        {parts[1] && <span>{parts[1].trim()}</span>}
      </Text>
    )
  }

  return (
    <section className="w-full bg-white">
      <div className="max-w-[1024px] mx-auto px-4">
        {title ? (
          <Text
            variant="headline"
            size="small"
            tag="p"
            className="text-primary-text"
          >
            {title}
          </Text>
        ) : null}

        <div className="flex flex-col gap-8 pt-7">
          {journeySteps.map((step, index) => (
            <div key={index} className="flex items-start gap-4">
              <div
                className={
                  'w-16 h-16 min-w-16 min-h-16 rounded-[20px] flex items-center justify-center text-[32px] text-white'
                }
                style={{
                  backgroundColor: cardBGColor,
                }}
              >
                {index + 1}
              </div>
              <div className="space-y-2">
                <div>
                  {renderTitleWithImage(step?.infoTitle, step?.replaceImage)}
                </div>
                {step?.infoBanner ? (
                  <div
                    className="rounded-lg bg-[#EEF2FF] px-1.5 py-1 flex items-center gap-2"
                    style={{
                      backgroundColor: step?.infoBanner?.backgroundColor,
                    }}
                  >
                    <Text
                      variant="body"
                      size="small"
                      tag="p"
                      className="text-primary-text"
                    >
                      {step?.infoBanner?.text}
                    </Text>
                    <img
                      src={step?.infoBanner?.partnerImage}
                      alt=""
                      className="w-[50px] h-5 object-contain"
                    />
                  </div>
                ) : null}
                <Text
                  tag="p"
                  variant="body"
                  size="large"
                  className="text-primary-text !leading-[1.3] opacity-80"
                  dangerouslySetInnerHTML={{ __html: step.infoDescription }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HowItWorksSection
